import { httpAxios } from "../utils/httpHelper";
export async function login(url,loginData) {
    const result = await httpAxios
      .post(url, loginData)
      .then((response) => response.data);
    return result;
  }
  export async function getProfile(config) {
    const result = await httpAxios.get("/profile",config)
      .then((response) => response.data);
    return result;
}

export async function updateProfile(payload,config) {
  const result = await httpAxios.put("/profile",payload,config)
    .then((response) => response.data);
  return result;
}

export async function getChat(payload,config) {
  const result = await httpAxios.post("/chat",payload,config)
    .then((response) => response.data);
  return result;
}

export async function logoutUser(config) {
  const result = await httpAxios.post("/logout",{},config)
    .then((response) => response.data);
  return result;
}


